import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// The single-target edit. Enforces the legal-transition matrix server-side.
// "not-entered" is accepted where the matrix allows it and removes the
// membership row (it is the absence of one) — only a winner's removal stays
// CSV-only.
export const updateMembershipStatus = async (cycleId, userId, status) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.put(
    `/awards-service-api/admin/cycles/${cycleId}/memberships/${userId}`,
    { status },
    { headers },
  );

  return response.data;
};
